// extracted by mini-css-extract-plugin
export default {"ageGen":"style_ageGen__cf-D0"};